import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { TrustBadges } from '../ui/TrustBadges';
import { trackEvent } from '../MetaPixel';
export function CTAFinal() {
  return <section id="cta-final" className="bg-verde-oscuro py-[120px] text-center" style={{
    backgroundImage: `
          radial-gradient(ellipse at 30% 40%, rgba(45, 122, 82, 0.4) 0%, transparent 60%),
          radial-gradient(ellipse at 70% 60%, rgba(201, 162, 39, 0.15) 0%, transparent 50%)
        `
  }} data-id="element-122">
      <div className="container-custom" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-124">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="inline-block bg-dorado/15 text-dorado-claro text-[12px] font-semibold tracking-[2px] uppercase px-4 py-1.5 rounded-[2px] mb-5" data-id="element-125">
            Última oportunidad
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="font-display text-[clamp(30px,5vw,52px)] font-black text-blanco leading-[1.2] mb-5" data-id="element-126">
            Ya es suficiente de vivir
            <br data-id="element-127" />
            con miedo a comer.
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.35,
          duration: 0.5
        }} className="text-[18px] text-white/80 max-w-[560px] mx-auto mb-10 leading-[1.8]" data-id="element-128">
            El Protocolo Digestivo de 72 Horas™ te da el sistema que necesitás
            para entender tu digestión, identificar lo que realmente te afecta y
            recuperar el control de tu vida.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.55,
          duration: 0.5
        }} className="w-full max-w-[320px] mx-auto" data-id="element-129">
            <div id="checkout-btn" data-id="element-130" />
            <Button href="https://infoproductosx10.com/cart/47182196703410:1" variant="primary" fullWidth className="!py-[22px] !text-[18px]" onClick={() => trackEvent('InitiateCheckout', {
            value: 17990,
            currency: 'CLP',
            content_name: 'Protocolo Digestivo 72 Horas'
          })} data-id="element-131">
              Acceder hoy por $17.990
            </Button>
            <TrustBadges theme="dark" className="mt-5" data-id="element-132" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}